module.exports = __webpack_public_path__ + "img/bom5.068708b6.png";